<!-- ============================================================== -->
<!-- sidebar -->
<!-- ============================================================== -->
<!-- <div class="user-profile" style="background: url(assets/images/background/user-info.jpg) no-repeat;"> -->
<!-- User profile image -->
<!-- <div class="profile-img"> <img src="assets/images/users/profile.png" alt="user"> </div> -->
<!-- User profile text-->
<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->
<!-- <div class="profile-text"><a [matMenuTriggerFor]="sdprofile" class=""> Markarn Doe <i class="ti-angle-down font-12 m-l-5"></i></a></div>
    <mat-menu #sdprofile="matMenu" class="mymegamenu">
        <button mat-menu-item>
            <mat-icon>settings</mat-icon> Settings </button>
        <button mat-menu-item>
            <mat-icon>account_box</mat-icon> Profile </button>
        <button mat-menu-item>
            <mat-icon>notifications_off</mat-icon> Disable notifications </button>
        <button mat-menu-item>
            <mat-icon>exit_to_app</mat-icon> Sign Out </button>
    </mat-menu> -->

<!-- </div> -->
<!-- { state: 'Nutritionistform', type: 'link', name: 'sidenav.nutritionistform', icon: 'view_comfy' }, -->
<!-- { state: 'Nuttestquiz', type: 'link', name: 'sidenav.nuttest', icon: 'view_comfy' }, -->

<mat-nav-list appAccordion>
    <mat-list-item appAccordionLink>
        <a (click)="inputSideNav.close()" class="" fxLayoutGap="10px" routerLink="/sites" appAccordionToggle>
            <mat-icon>view_comfy</mat-icon>
            <span>{{'MAIN-APP.SITES' | translate}}</span>
            <span fxFlex></span>
        </a>
    </mat-list-item>
    <mat-list-item appAccordionLink>
        <a (click)="inputSideNav.close()" class="" fxLayoutGap="10px" routerLink="/mail-list-table" appAccordionToggle>
            <mat-icon>view_comfy</mat-icon>
            <span>{{'MAIN-APP.MAILING-LIST' | translate}}</span>
            <span fxFlex></span>
        </a>
    </mat-list-item>
    <mat-list-item appAccordionLink>
        <a (click)="inputSideNav.close()" class="" fxLayoutGap="10px" routerLink="/email-table" appAccordionToggle>
            <mat-icon>view_comfy</mat-icon>
            <span>{{'MAIN-APP.MAILING' | translate}}</span>
            <span fxFlex></span>
        </a>
    </mat-list-item>
    <mat-list-item appAccordionLink>
        <a (click)="inputSideNav.close()" class="" fxLayoutGap="10px" routerLink="/log-table" appAccordionToggle>
            <mat-icon>view_comfy</mat-icon>
            <span>{{'MAIN-APP.LOGS' | translate}}</span>
            <span fxFlex></span>
        </a>
    </mat-list-item>

</mat-nav-list>